import type { LegalBlock } from '../../models/ast';
import { getStylesRegistry } from '../../styles/registry';

export function requiresKeepWithNext(block: LegalBlock): boolean {
  // Style-driven rule first
  const registry = getStylesRegistry();
  const styleId = (block as any).styleId as string | undefined;
  const styleFlag = styleId ? registry.paragraphStyles?.[styleId]?.keepWithNext === true : false;
  // Backward-compatible semantic fallbacks
  const lcKeep = (block as any).legalConstraints?.keepWithNext === true; // cast to avoid union narrowing due to atomic blocks
  return styleFlag || lcKeep || block.type === 'Heading' || block.type === 'Clause';
}


